import {
  MenuItem,
  InputLabel,
  FormControl,
  SelectProps,
  FormControlProps,
  Select as MuiSelect,
} from "@mui/material";

type Props<T> = Omit<FormControlProps, "onChange"> &
  SelectProps<T> & {
    options: { value: string; label: string }[];
  };

export const Select = <T,>({
  size,
  label,
  style,
  options,
  fullWidth,
  ...props
}: Props<T>) => {
  return (
    <FormControl fullWidth={fullWidth} style={style} size={size}>
      <InputLabel>{label}</InputLabel>
      <MuiSelect size={size} label={label} {...props}>
        {options.map((option, index) => (
          <MenuItem
            value={option.value}
            key={`select-option-${option.value}-${index}`}
          >
            {option.label}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
};
